import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import { useUserContext } from "../UserContext";
import { canUseCalendarV2, oldCalendarPathFor } from "../calendarV2/calendarV2Access";

const InstructorSchedulePage = lazy(() => import("../calendarV2/InstructorSchedulePage"));

/** „Grafic instructori” (/admin|manager/grafic-instructori) — merge cu calendarul nou; cine nu-l are — la calendarul de acum. */
export default function InstructorScheduleRoute() {
   const { user } = useUserContext() || {};
   if (user && !canUseCalendarV2(user)) return <Navigate to={oldCalendarPathFor(user)} replace />;
   return (
      <Suspense
         fallback={
            <main className="main">
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se încarcă graficul…</span>
               </div>
            </main>
         }
      >
         <InstructorSchedulePage />
      </Suspense>
   );
}
